<div [class.loader-hidden]="!show">
  <div class="fixed w-full top-0 left-0 opacity-100 z-[500000]">
    <mat-progress-bar mode="indeterminate" color="primary" *ngIf="show"></mat-progress-bar>
  </div>
</div>
